import React from 'react'
import abimg2 from '../../images/about/about4.jpg'


const About = (props) => {
    return (
        <section className={`wpo-about-section-s3 section-padding ${props.abClass}`}>
            <div className="container">
                <div className="wpo-section-title-s2">
                    <span>About Us</span>
                    <h2>Why Clients Choose Wilson Tamuka Attorneys?</h2>
                </div>
                <div className="wpo-about-section-wrapper">
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-md-12 col-12">
                            <div className="wpo-about-content">
                                <h2>Built on Trust, Excellence & Innovation</h2>
                                <div className="wpo-about-content-inner">
                                    <p>Wilson Tamuka Attorneys (WTA) is a full legal service firm, locally and internationally. founded by Wilson Tamuka Mugaviri, a seasoned legal practitioner with a passion for blending tradition, innovation, and ethical leadership. Registered with the Law Society of Zimbabwe, we offer a full-service legal experience tailored to the needs of individuals, corporates, and institutions.</p>
                                    <p>We combine technical excellence with emotional intelligence, ensuring that every client feels heard, protected, and empowered. Whether advising on complex commercial transactions, guiding families through estate planning, or representing clients in litigation, WTA delivers with clarity, compassion, and strategic foresight.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-12 col-12">
                            <div className="wpo-about-img">
                                <img src={props.abimg} alt="" />
                                <div className="about-img-inner">
                                    <img src={abimg2} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="visible-text">
                        <h2>About</h2>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;